var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2248_119887)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2248_119887",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.15256e-07H20V20H0V-7.15256e-07Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2248_119887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4526 14.4247L16.6126 12.5847C16.2796 12.2518 15.8624 12.0154 15.4057 11.901C14.9489 11.7865 14.4696 11.7982 14.0189 11.9348C13.5683 12.0714 13.1632 12.3277 12.8468 12.6765C12.5304 13.0253 12.3147 13.4535 12.2226 13.9153C9.18835 13.3479 6.2373 10.409 6.05361 7.78211C6.56952 7.687 7.04436 7.43738 7.41519 7.06632C7.90304 6.57835 8.1771 5.91659 8.1771 5.22658C8.1771 4.53657 7.90304 3.87482 7.41519 3.38685L5.57572 1.54737C5.08784 1.05956 4.42617 0.785509 3.73625 0.785509C3.04632 0.785509 2.38465 1.05956 1.89677 1.54737C-3.62165 7.06632 12.9341 23.6221 18.4526 18.1032C18.9403 17.6154 19.2144 16.9538 19.2144 16.264C19.2144 15.5741 18.9403 14.9125 18.4526 14.4247Z",
    fill: "#1B293F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2248_119887"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTel);
export default __webpack_public_path__ + "static/media/tel.d72d8f1e97ac6fb0d41e979d0edd524e.svg";
export { ForwardRef as ReactComponent };